<template>
  <div class="uk-background-secondary uk-light uk-padding uk-padding-remove-horizontal">
    <div class="uk-container uk-container-large">
      <div class="uk-grid" uk-grid>
        <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-1">
          <img alt="Radioplayer logo" src="~@/assets/images/rp-misc-logo-inverse.png" class="uk-width-1-1@m uk-width-1-2@s uk-width-3-5" />
        </div>
        <div class="uk-width-2-5@l uk-width-1-4@m uk-visible@m">

        </div>
        <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-2">
          <ul class="uk-nav uk-nav-default">
            <li><a href="/discover/">Discover</a></li>
            <li><a href="/docs/how-to/">Documentation</a></li>
            <li class="uk-active"><a href="/console/">Console</a></li>
            <li><a href="/use-cases/">Use Cases</a></li>
          </ul>
        </div>
        <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-2">
          <ul class="uk-nav uk-nav-default">
            <li><a href="https://radioplayer.co.uk/privacy/">Privacy Policy</a></li>
            <li><a href="/contact/">Contact</a></li>
            <li><a href="https://radioplayer.org/updates-insights/news/">News</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
  };
</script>

<style scoped>

</style>
